<div class="flex overflow-hidden shadow-md bg-white h-full">
  <app-confirm-dialog
    [show]="showConfirmDialog"
    [message]="message"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
  ></app-confirm-dialog>

  <!-- Tabs laterais -->
  <div class="w-1/8 bg-gray-50 border-r border-cinza">
    <ul class="flex flex-col">
      @for (tab of tabs; track $index) {
        <li
          (click)="selectTab(tab.id)"
          class="cursor-pointer px-4 py-3 text-sm font-medium border-b transition-colors duration-200"
          [ngClass]="{
            'bg-red-light  border-b-4 border-primary': activeTab === tab.id,
            'hover:bg-gray-100 text-gray-600 border-cinza': activeTab !== tab.id,
          }"
          *kaHasRoles="tab.visibility; resource: 'tefbox-api-lojista'"
        >
          {{ tab.title }}
        </li>
      }
    </ul>
  </div>

  <!-- Conteúdo da tab -->
  <div class="flex-1 p-6 h-full overflow-x-auto">
    @switch (activeTab) {
      @case (1) {
        <ng-container *kaHasRoles="['lojista']; resource: 'tefbox-api-lojista'">
          <div class="animate-fadeIn">
            <h2 class="text-lg font-semibold mb-2">Informações</h2>
            <form [formGroup]="userInfo" class="flex flex-col gap-4 p-8" (submit)="salvar()">
              <div class="flex justify-between items-center space-x-4">
                <p class="">ClientId:</p>
                <input
                  type="text"
                  formControlName="clientId"
                  class="border p-2 rounded border-primary w-[36ch]"
                />
              </div>
              <div class="flex justify-between items-center space-x-4">
                <p class="">MerchantId:</p>
                <input
                  type="text"
                  formControlName="merchantId"
                  class="border p-2 rounded border-primary w-[36ch]"
                />
              </div>
              <div class="flex justify-between items-center space-x-4">
                <div class="flex gap-2">
                  <p class="">CNPJ:</p>
                  <img
                    src="/icons/edit.svg"
                    alt="edit"
                    width="20"
                    class="cursor-pointer"
                    (click)="editCNPJ()"
                  />
                </div>
                <input
                  #cnpjInput
                  type="text"
                  formControlName="cnpj"
                  class="border p-2 rounded border-primary w-[36ch]"
                />
              </div>

              @if (userInfo.controls.cnpj.enabled) {
                <span class="text-red-500 font-semibold"
                  >*Ao editar todos os checkouts e pareamentos serão apagados</span
                >
                <app-button class="self-end" type="submit">Salvar</app-button>
              }
            </form>
          </div>
        </ng-container>
      }
      @case (2) {
        <ng-container>
          <div class="animate-fadeIn">
            <h2 class="text-lg font-semibold mb-2">Configuration</h2>
            <p class="text-gray-700">Conteudo</p>
          </div>
        </ng-container>
      }
      @case (4) {
        <ng-container *kaHasRoles="['cliente']; resource: 'tefbox-api-lojista'">
          <div class="animate-fadeIn h-full">
            <h2 class="text-lg font-semibold">Segurança</h2>
            <div class="flex justify-between">
              <p class="text-xs text-black/60">Tokens de autorização da automação comercial</p>
              <app-button>Adicionar</app-button>
            </div>
            <table class="table-auto min-w-full border-collapse">
              <thead>
                <tr class="font-bold border-b-2 border-cinza">
                  <th class="px-3 py-2 text-left whitespace-nowrap">Merchant:</th>
                  <th class="px-3 py-2 text-left whitespace-nowrap">CNPJ:</th>
                  <th class="px-3 py-2 text-left">Token:</th>
                  <th class="px-3 py-2 text-left whitespace-nowrap">Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                @for (token of tokens; track $index) {
                  <tr>
                    <td class="px-3 py-2 whitespace-nowrap">{{ token.merchantLabel }}</td>
                    <td class="px-3 py-2 whitespace-nowrap">{{ token.cnpj }}</td>
                    <td class="px-3 py-2 max-w-[500px]">
                      <app-key-viewer [keyValue]="token.token"> </app-key-viewer>
                    </td>
                    <td class="px-3 py-2 whitespace-nowrap">
                      <app-badge
                        [texto]="statusToken(token.expires) ? 'Válido' : 'Expirado'"
                        [variant]="statusToken(token.expires) ? 'primary' : 'secondary'"
                      />
                    </td>
                    <td class="px-3 py-2 w-1">
                      <app-button (click)="updateToken(token.merchantId)">Atualizar</app-button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </ng-container>
      }
    }
  </div>
</div>
